var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6667 80H69.3333V90.6666H58.6667V80ZM58.6667 37.3333H69.3333V69.3333H58.6667V37.3333ZM63.9467 10.6667C34.5067 10.6667 10.6667 34.56 10.6667 64C10.6667 93.44 34.5067 117.333 63.9467 117.333C93.44 117.333 117.333 93.44 117.333 64C117.333 34.56 93.44 10.6667 63.9467 10.6667ZM64 106.667C40.4267 106.667 21.3333 87.5733 21.3333 64C21.3333 40.4267 40.4267 21.3333 64 21.3333C87.5733 21.3333 106.667 40.4267 106.667 64C106.667 87.5733 87.5733 106.667 64 106.667Z",
    fill: "#134044"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.de861255b39d574269166fff75c7604c.svg";
export { ForwardRef as ReactComponent };